import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAppSelector } from '../hooks';
import { getAuthUser } from '../reducers/authReducer';
import { paths } from '../paths';

export const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const authUser = useAppSelector((s) => getAuthUser(s));

  return (
    <Route
      {...rest}
      render={({ location }) =>
        authUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: paths.LOGIN,
              state: { redirectTo: location.pathname + location.search },
            }}
          />
        )
      }
    />
  );
};
export default PrivateRoute;